export default {
  blue: '#4f9da6',
  red: '#ff5959',
  orange: '#facf5a',
  black: '#233142',
};
